import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock, Instagram } from "lucide-react";
import { FaWhatsapp } from 'react-icons/fa';
import logon from '../images/logon.webp';

// Button component
const Button = ({ children, className, ...props }) => (
  <button className={`px-4 py-2 rounded-md transition-all duration-300 ease-in-out ${className}`} {...props}>
    {children}
  </button>
);

// Input component
const Input = ({ className, ...props }) => (
  <input className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#DBAC5B] focus:border-transparent ${className}`} {...props} />
);

// Textarea component
const Textarea = ({ className, ...props }) => (
  <textarea className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#DBAC5B] focus:border-transparent ${className}`} {...props} />
);

// Main ContactPage component
export default function Contacto() {
  const [nombre, setNombre] = useState('');
  const [email, setEmail] = useState('');
  const [telefono, setTelefono] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [errors, setErrors] = useState({});
  const [statusMessage, setStatusMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  // Validación de los campos
  const validateFields = () => {
    let newErrors = {};

    if (!nombre.trim()) {
      newErrors.nombre = 'El nombre es obligatorio.';
    }

    // Validación de email con regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      newErrors.email = 'El correo electrónico no es válido.';
    }

    // Validación de teléfono (solo números, mínimo 7 dígitos)
    const telefonoRegex = /^[0-9]{7,15}$/;
    if (!telefonoRegex.test(telefono)) {
      newErrors.telefono = 'El teléfono debe contener solo números y ser de entre 7 y 15 dígitos.';
    }

    if (!mensaje.trim()) {
      newErrors.mensaje = 'El mensaje es obligatorio.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateFields()) {
      return;
    }
  
    const formData = { nombre, email, telefono, mensaje };
  
    setIsLoading(true);
    try {
      const response = await fetch('https://funerariacoquimbo.cl/backend/phpBackend.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
  
      const result = await response.json();
  
      if (response.ok) {
        if (result.errors) {
          setErrors(result.errors);
        } else {
          setStatusMessage({ type: 'success', text: '¡Gracias por contactar con nosotros! Le responderemos a la brevedad.' });
          setNombre('');
          setEmail('');
          setTelefono('');
          setMensaje('');
          setFormSubmitted(true);
        }
      } else {
        setStatusMessage({ type: 'error', text: 'Hubo un problema al enviar el mensaje.' });
      }
    } catch (error) {
      console.error('Error al enviar el formulario:', error);
      setStatusMessage({ type: 'error', text: 'Error al enviar el formulario.' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="w-full py-12 md:py-24 lg:py-20">
      <div className="container px-4 md:px-6 mx-auto max-w-5xl">
        <div className="flex flex-col items-center space-y-6">
        <img 
      src={logon}
      alt="Funeraria Coquimbo"
      className="h-24  md:h-24 mb-4 transition-transform duration-300 ease-in-out hover:scale-105"
    />              </div>

        <div className="grid mt-8 gap-16 lg:grid-cols-2 items-center">
          <div className="space-y-4 mx-auto">
            <h2 className="lg:text-4xl text-3xl text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 font-bold mb-6">
              Estamos aquí para <span className="text-[#DBAC5B]">ayudarle</span>
            </h2>
            <p className="  text-gray-600 text-xl">
              En Funeraria Coquimbo entendemos que necesita apoyo en momentos difíciles. Nuestro equipo está disponible las <span className="text-[#DBAC5B]">24 horas</span> para atenderle con compasión y profesionalismo.
            </p>

            {/* Información de contacto */}
            <div className="space-y-4 text-xl">
              <h2 className="text-3xl lg:text-4xl text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 font-semibold mt-10">
              <span className="text-[#DBAC5B]">Información </span>de contacto
              </h2>
              <div className="flex items-center space-x-2">
                <Phone className="h-6 w-6  text-[#DBAC5B]" />
                <span className='text-gray-700'>+56 9 8322 1037</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-6 w-6 text-[#DBAC5B]" />
                <span className='text-gray-700'>rojasllewellynltda@gmail.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin className="h-6 w-6 text-[#DBAC5B]" />
                <span className='text-gray-700'>Av. Pedro Nolasco Videla 520, Coquimbo, Chile</span>
              </div>
              <div className="flex items-center space-x-2">
                <Clock className="h-6 w-6 text-[#DBAC5B]" />
                <span className='text-gray-700'>Atención 24/7</span>
              </div>
            </div>

            <div className="pt-4">
              <h2 className="text-3xl text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 lg:text-4xl  font-semibold mt-4">
                Síguenos en <span className="text-[#DBAC5B]">redes sociales</span>
              </h2>
              <div className="flex pt-3 space-x-4">
                <a href="https://wa.me/+56983221037" target="_blank" rel="noopener noreferrer" aria-label="Whatsapp">
                  <FaWhatsapp className="h-8 w-8 text-[#DBAC5B] ml-2 hover:text-[#A0A0A0] transition-transform transform hover:scale-110 duration-300 ease-in-out" />
                </a>
                <a href="https://www.instagram.com/funerariacoquimbo" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <Instagram className="h-8 w-8 text-[#DBAC5B]  ml-4 hover:text-[#A0A0A0] transition-transform transform hover:scale-110 duration-300 ease-in-out" />
                </a>
              </div>
            </div>
          </div>

          {!formSubmitted ? (
            <form onSubmit={handleSubmit} className="space-y-6 my-auto">
              {statusMessage && (
                <p className={`text-center ${statusMessage.type === 'success' ? 'text-green-500' : 'text-red-500'}`}>
                  {statusMessage.text}
                </p>
              )}

              <div>
                <h2 className='text-3xl text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 lg:text-4xl font-bold mb-2'>Formulario de<span className="text-[#DBAC5B]"> contacto</span></h2>

                <label htmlFor="nombre" className="block text-sm font-medium text-gray-700">
                  Nombre
                </label>
                <Input
                  id="nombre"
                  type="text"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  required
                  className="mt-1"
                />
                {errors.nombre && <p className="text-red-500 text-sm">{errors.nombre}</p>}
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                  Correo Electrónico
                </label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="mt-1"
                />
                {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
              </div>

              <div>
                <label htmlFor="telefono" className="block text-sm font-medium text-gray-700">
                  Teléfono
                </label>
                <Input
                  id="telefono"
                  type="tel"
                  value={telefono}
                  onChange={(e) => setTelefono(e.target.value)}
                  required
                  className="mt-1"
                />
                {errors.telefono && <p className="text-red-500 text-sm">{errors.telefono}</p>}
              </div>

              <div>
                <label htmlFor="mensaje" className="block text-sm font-medium text-gray-700">
                  Mensaje
                </label>
                <Textarea
                  id="mensaje"
                  value={mensaje}
                  onChange={(e) => setMensaje(e.target.value)}
                  required
                  className="mt-1"
                  rows={4}
                />
                {errors.mensaje && <p className="text-red-500 text-sm">{errors.mensaje}</p>}
              </div>

              <Button
                type="submit"
                className={`w-full bg-[#DBAC5B] hover:text-[#A0A0A0] text-white ${isLoading ? 'cursor-not-allowed opacity-50' : ''}`}
                disabled={isLoading}
              >
                {isLoading ? 'Enviando...' : 'Enviar Mensaje'}
              </Button>
            </form>
          ) : (
            <div className="text-center text-lg font-semibold text-green-600">
              <p>¡Gracias por su contactar con nosotros!</p>
              <p>Le responderemos a la brevedad.</p>
            </div>
          )}
        </div>
        

        <div className="text-center my-16">
      <h2 className="text-3xl font-semibold text-gray-800">
        Valoramos su <span className="text-[#DBAC5B]">opinión</span>
      </h2>
      <p className="text-gray-600 mt-4">
        Su experiencia es importante para nosotros y para otras familias que puedan necesitar nuestros servicios.
      </p>
      <p className="text-gray-600 mb-6">
        Si ya ha utilizado nuestros servicios, le agradecemos que comparta su experiencia dejando una reseña.
      </p>
      <a
        href="https://www.google.com/maps/place/Funeraria+Coquimbo/@-29.9340618,-71.3343781,13z/data=!4m12!1m2!2m1!1sfuneraria+coquimbo!3m8!1s0x9691c9e976ef5029:0xd7d09c4f2f916806!8m2!3d-29.9655068!4d-71.3363385!9m1!1b1!15sChJmdW5lcmFyaWEgY29xdWltYmJvkgEMZnVuZXJhbF9ob21lmgEjQ2haRFNVaE5NRzluUzBWSlEwRm5TVVI1TWpsUE4wdEJFQUXgAQA!16s%2Fg%2F11r3xh9m0_?entry=ttu&g_ep=EgoyMDI0MTAyMC4xIKXMDSoASAFQAw%3D%3D"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block bg-[#DBAC5B] text-white text-lg py-2 px-6 rounded-md hover:text-[#A0A0A0] transition-all duration-300 max-w-xs mx-auto"
      >
        Dejar reseña en Google
      </a>
    </div>
      </div>
    </section>
  );
}


